module.exports = __webpack_public_path__ + "img/pixeltrue-web-development.c0c6e550.svg";